<template>
  <div class="usage-wrap" ref="usageWrap">
    <template>
      <slot/>
    </template>


    <div
        id="barChart"
        ref="barChart"
        style="height:126px">
    </div>
  </div>
</template>

<script>
export default {
  name: "Usage",
  props: {
    lineChartData: {
      type: Array,
      require: true
    },
    xAxis: {
      type: Object,
      default: () => {

      }
    },
    grid: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      barChart: null
    };
  },
  methods: {
    refreshBarChart() {
      const barChart = this.barChart;
      const option = {
        color: '#DBE6FC',
        grid: {
          top: "10%", // 设置顶部边距为 20%
          left: 0,
          right: 0,
          bottom: 0, // 设置底部边距为 20%
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: ["S", "M", "T", "W", "T", "F", "S"],
          axisLabel: {
            fontSize: 9,
          },
          axisTick: {
            show: true,
            alignWithLabel: true // 刻度线与标签对齐
          },
          axisLine: {
            lineStyle: {
              color: '#D9D9D9',
            }
          }
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              color: '#D9D9D9',
              width: 1,
              dashOffset: 10,
              type: 'dashed' // 设置为虚线
            }
          },

          axisLine: {
            lineStyle: {
              color: '#D9D9D9',
            }
          }
        },
        series: [
          {
            data: this.lineChartData,
            type: "bar",
            barWidth: "8",

            itemStyle: {
              color: '#DBE6FC',
              normal: {
                borderRadius: [8, 8, 0, 0], // 设置顶部左右两个角的圆角半径为 5
                width: 4
              }
            }
          }
        ]
      };
      option.xAxis = { ...option.xAxis, ...this.xAxis };
      option.grid = { ...option.grid, ...this.grid };
      barChart.setOption(option);
    }
  },
  watch: {
    lineChartData(val) {
      this.refreshBarChart();
    }
  },
  mounted() {
    this.$nextTick(() => {
      const width = this.$refs.usageWrap.clientWidth;

      this.$refs.barChart.style.width = `${width}px`;
      this.barChart = this.$echarts.init(this.$refs.barChart);


      this.refreshBarChart();
    });


  }
};
</script>

<style scoped lang="less">
.usage-wrap {
  font-size: 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: flex-start;

  .title-wrap {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}

.usage-value {
  font-weight: bold;
  font-size: 24px;
}
</style>